// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2XXrn","info":"Note_info__3lgK3","note":"Note_note__1IOER","actions":"Note_actions__2meMI"};